import { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import DataTable from 'react-data-table-component';
import { FaPlus, FaSearch, FaSearchDollar, FaUserFriends } from 'react-icons/fa';
import { MdClose, MdDelete, MdEdit } from 'react-icons/md';
import styles from "./coordinadores.module.css";
import { api } from '../../utils/services/api';
import { APP_OPTIONS, SERVICE } from '../../utils/constants/services';
import Swal from 'sweetalert2';
import WindowLayout from '../../utils/layout/windowsLayout';
import ModalCoordinadores from './coordinadoresModal';
import { GrClearOption } from 'react-icons/gr';



const customStyles = {
    headRow: {
        style: {
            minHeight: "40px",
            backgroundColor: "#046cc2",
            fontSize: "15px",
            color: "white",
        },
    },


};
export default function Coordinadores(props) {
    const { windowSize,setMenuActual } = useAuth();

    const [showModal, setShowModal] = useState(false);
    const [dataTable, setDataTable] = useState([]);
    const [roles, setRoles] = useState([]);
    const [userEdit, setUserEdit] = useState(null);
    const [ofices, setOfices] = useState([]);
    const [loadingTable, setLoadingTable] = useState(false);
    const [totalRows, setTotalRows] = useState(10);
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [textSearch,setTextSearch] = useState("");
    const [textSearchPrev,setTextSearchPrev] = useState("");

    const { estados, municipios, codigos } = useAuth();

    const columns = [
        {
            name: '',
            cell: (row) => {
                return (
                    <div style={{ display: "flex" }}>
                        <button className='btn btn-sm btn-primary' onClick={() => { setUserEdit(row); setShowModal(true); }}><MdEdit /></button>&nbsp;
                        <button className='btn btn-sm btn-danger' onClick={() => handleDelete(row.completeName, row.id)}><MdDelete /></button>
                    </div>
                )
            },
            width: "100px",
        },
        {
            name: 'ID',
            selector: row => row.id,
            width: "70px",
        },
        {
            name: 'Nombre',
            selector: row => row.completeName,
            width: "200px",
        },
        {
            name: 'Sucursal',
            selector: row => row.centralOfficeName,
            width: "200px",
        },
        {
            name: 'Estado',
            selector: row => row.stateName,
        },
        {
            name: 'Municipio',
            selector: row => row.municipalityName,
        },
        {
            name: 'Codigo Postal',
            selector: row => row.postalCodeName,
            width: "250px",
        },
        {
            name: 'Dirección',
            cell: row => (
                <div style={{
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                    lineHeight: '1.4'
                }}>
                    {row.address}
                </div>
            ),
            wrap: true,
            minWidth: '150px'
        },
        {
            name: 'Número',
            selector: row => row.phoneNumber,
        },
        {
            name: 'Fecha de Nacimiento',
            selector: row => row.dateOfBirth.split("T")[0],
            width: "190px",
        },
        {
            name: 'Fecha de Ingreso',
            selector: row => row.admissionDate.split("T")[0],
            width: "174px",
        },

    ];

    const handleDelete = (userName, userId) => {
        Swal.fire({
            title: "¿Esta segur@ que desea eliminar el coordinador " + userName + "?",
            showCancelButton: true,
            confirmButtonText: "Eliminar",
            denyButtonText: "Cancelar"
        }).then((result) => {
            /* Read more about isConfirmed, isDenied below */
            if (result.isConfirmed) {
                let payload = {
                    userName: userName
                }
                api(SERVICE.deleteCordinadores + `?CoordinatorsId=${userId}`, {}, "DELETE")
                    .then((data) => {
                        handleUpdate();
                    })
                    .catch((err) => {
                        console.log(err);
                    })
            }
        });

    }


    const handleGetOffice = () => {
        api(SERVICE.getOfices)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push({
                            value: element.id,
                            label: element.description,
                            stateId: element.stateId,
                            municipalityId: element.municipalityId
                        });

                    }
                }
                setOfices(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleUpdateNosearch = ()=>{
        let URL = SERVICE.getCordinadores + `?TypeSearch=1&Page=${page}&PageSize=${perPage}`;
        
        api(URL)
            .then((data) => {
                let arrayTemp = [];
                if(data && data.data && data.data.paginationInfo){
                    setTotalRows(data.data.paginationInfo.totalRecords);
                }
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        
                        let centralOfficeName = "";
                        let stateName = "";
                        let municipalityName = "";
                        let postalCodeName = "";
                        let search1 = ofices.findIndex(item => item.value === element.centralOfficeId);
                        if (search1 != -1) {
                            centralOfficeName = ofices[search1].label;
                        }
                        let search2 = estados.findIndex(item => item.value === element.stateId);
                        if (search2 != -1) {
                            stateName = estados[search2].label;
                        }
                        let search3 = municipios.findIndex(item => item.value === element.municipalityId);
                        if (search3 != -1) {
                            municipalityName = municipios[search3].label;
                        }
                        let search4 = codigos.findIndex(item => item.value === element.postalCodeId);
                        if (search4 != -1) {
                            postalCodeName = codigos[search4].label;
                        }
                        arrayTemp.push({
                            postalCodeName: postalCodeName,
                            municipalityName: municipalityName,
                            stateName: stateName,
                            centralOfficeName, centralOfficeName,
                            ...element
                        })

                    }
                }
                setDataTable(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    const handleUpdate = () => {
        let URL = SERVICE.getCordinadores + `?TypeSearch=1&Page=${page}&PageSize=${perPage}`;
        if(textSearch!=""){
            URL = URL +`&TextSearch=${textSearch}`;
        }
        setTextSearchPrev(textSearch);
        setTextSearch("");
        api(URL)
            .then((data) => {
                let arrayTemp = [];
                if(data && data.data && data.data.paginationInfo){
                    setTotalRows(data.data.paginationInfo.totalRecords);
                }
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        let centralOfficeName = "";
                        let stateName = "";
                        let municipalityName = "";
                        let postalCodeName = "";
                        let search1 = ofices.findIndex(item => item.value === element.centralOfficeId);
                        if (search1 != -1) {
                            centralOfficeName = ofices[search1].label;
                        }
                        let search2 = estados.findIndex(item => item.value === element.stateId);
                        if (search2 != -1) {
                            stateName = estados[search2].label;
                        }
                        let search3 = municipios.findIndex(item => item.value === element.municipalityId);
                        if (search3 != -1) {
                            municipalityName = municipios[search3].label;
                        }
                        let search4 = codigos.findIndex(item => item.value === element.postalCodeId);
                        if (search4 != -1) {
                            postalCodeName = codigos[search4].label;
                        }
                        arrayTemp.push({
                            postalCodeName: postalCodeName,
                            municipalityName: municipalityName,
                            stateName: stateName,
                            centralOfficeName, centralOfficeName,
                            ...element
                        })

                    }
                }
                setDataTable(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }
    // const handleUpdateRoles = () => {

    //     api(SERVICE.getRoles)
    //         .then((data) => {
    //             let arrayTemp = [];
    //             for (let index = 0; index < data.data.data.length; index++) {
    //                 const element = data.data.data[index];
    //                 arrayTemp.push({
    //                     id: element.id,
    //                     identifier: element.identifier,
    //                     description: element.description
    //                 })
    //             }
    //             setRoles(arrayTemp);
    //         })
    //         .catch((err) => {

    //         })
    // }
    
    const handlePageChange = (newPage) => {
        setPage(newPage);
    };

    const handlePerRowsChange = (newPerPage) => {
        setPerPage(newPerPage);
    };
    useEffect(() => {
        if (ofices.length > 0) {
            handleUpdate();
        }
    }, [ofices, page, perPage])
    useEffect(() => {
        handleGetOffice();
    }, [])
    return (
        <>
            <WindowLayout
                title="COORDINADORES"
                route={["Inicio","Catálogos","Coordinadores"]}
                actions={[()=>setMenuActual("homeMenu"),()=>setMenuActual("catalogMenu")]}
                icon={<FaUserFriends />}
            >
                <div className='paperContainer'>
                    <div className={styles.containerButtomTop}>
                        <button className='btn btn-sm btn-success' onClick={() => setShowModal(!showModal)}><FaPlus /></button>
                    </div>

                    <div class="input-group flex-nowrap" style={{marginBottom:"10px",width: windowSize.width<750?"100%":"500px"}}>
                        <input type="text" class="form-control" placeholder="Busqueda" value={textSearch} onChange={(e)=>setTextSearch(e.target.value)} aria-describedby="addon-wrapping"/>
                        <button className='btn btn-primary' onClick={handleUpdate}><FaSearch /></button>
                    </div>
                    <div class="input-group flex-nowrap containerSearchPrev" style={{display:textSearchPrev!==""?"flex":"none"}}>
                         <div class="badgeSearch">Buscando por: <b>{textSearchPrev}</b> </div><div onClick={()=>{
                            setTextSearch("");
                            setTextSearchPrev("");
                            handleUpdateNosearch();
                         }} className='divCloseSearch'><MdClose></MdClose></div>
                    </div>
                    <DataTable
                        columns={columns}
                        data={dataTable}
                        customStyles={APP_OPTIONS.TABLE_SETTING}
                        pagination
                        paginationServer
                        paginationTotalRows={totalRows}
                        paginationPerPage={perPage}
                        paginationRowsPerPageOptions={[10, 20, 30, 50]}
                        onChangePage={handlePageChange}
                        onChangeRowsPerPage={handlePerRowsChange}
                        progressPending={loadingTable}
                        persistTableHead
                        fixedHeader
                        fixedHeaderScrollHeight="600px"
                        responsive
                    />

                </div>
            </WindowLayout>
            <ModalCoordinadores
                show={showModal}
                setShow={setShowModal}
                roles={roles}
                dataEdit={userEdit}
                setDataEdit={setUserEdit}
                handleUpdate={handleUpdate}
                municipios={municipios}
                estados={estados}
                codigos={codigos}
                ofices={ofices}
            />
        </>
    );
} 